import React, { useEffect } from 'react';
import { useApi } from '../../../hooks/api';
import Artikel from '../../artikel/Artikel';
import ButtonLoadmore from '../../button/ButtonLoadmore';

import './KegiatanSection.css';
const payload = {
  "pagination": {
    "current": 1, "pageSize": 3
  },
  "filtering": {
    "kategori": "Kegiatan dan publikasi"
  }
};

const KegiatanSection = () => {
  const { data, loading, refetch } = useApi('/api/kegiatan-sekolah/status');

  useEffect(() => {
    refetch("POST", payload);
  }, [refetch]);

  return (
    <section id="kegiatan" className="kegiatan-section">
      <div className="feature-header">
        <div className="divider-line"></div>
        <h2>Kegiatan dan Publikasi</h2>
      </div>
      <Artikel isLoading={loading} items={data && data.list} onRefetch={() => {
        refetch("POST", payload);
      }} />
        <ButtonLoadmore payload={payload} isShow={data && data.list.length > 0 ? true : false} refetch={() => refetch("POST", payload)} />
    </section>
  );
};

export default KegiatanSection;
